import axios from "axios";
import { Cookies } from "react-cookie";
import * as constants from "./constants";
var cookies = new Cookies();
export async function $post(url, header = {}, body = {}) {
  try {
    const all = await axios.post(url, body, {
      headers: header,
    });

    return all;
  } catch (err) {
    throw err;
    console.log(err);
  }
}


export async function $POST(url, body = {}) {
  console.log("constants.BASE_URL",constants.BASE_URL)
  try {
    const all = await axios.post( constants.BASE_URL + url, body, {
      headers:{
        Authorization:cookies.get("employee_token_str"),
      }
    });

    return all;
  } catch (err) {
    throw err;
    console.log(err);
  }
}